import React from 'react'
import PropTypes from 'prop-types'
import { Form, Icon, Input, Button, Checkbox, Alert } from 'antd'
import { defineMessages } from 'react-intl'

import ForgotPasswordModal from './ForgotPasswordModal'
import './Login.scss'

const messages = defineMessages({
  alertLoginFail: '登入失敗',
  placeholderUsername: '用戶名稱',
  placeholderPassword: '密碼',
  labelForgotPassword: '忘記密碼?',
  labelRememberMe: '記住我',
  buttonLogin: '登入',
})

class LoginForm extends React.Component {
  static contextTypes = {
    intl: PropTypes.object,
  };

  static propTypes = {
    isAuthenticating: PropTypes.bool,
    errorMessage: PropTypes.string,
    header: PropTypes.node,
    style: PropTypes.object,
    onSubmit: PropTypes.func,
    forgotPassword: PropTypes.func,
    isForgotPasswordLoading: PropTypes.bool,
    isForgotPasswordSuccess: PropTypes.bool,
    forgotPasswordErrorMessage: PropTypes.string,
    initForgotPassword: PropTypes.func,
    form: PropTypes.Object
  };

  static defaultProps = {
    header: null,
    errorMessage: ''
  };

  constructor (props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      showAlert: false,
      enableRememberMe: false,
      showForgotPasswordModal: false,
    }
  }

  componentWillReceiveProps (nextProps) {
    if (!nextProps.errorMessage) {
      this.onAlertDismiss()
    } else if (
      nextProps.errorMessage &&
      this.state.showAlert === false &&
      this.props.isAuthenticating &&
      !nextProps.isAuthenticating
    ) {
      this.onAlertShow()
    }
  }

  onUsernameChange = (event) => {
    this.setState({
      username: event.target.value
    })
  }

  onPasswordChange = (event) => {
    this.setState({
      password: event.target.value
    })
  }

  onAlertDismiss = () => {
    this.setState({ showAlert: false })
  }

  onAlertShow = () => {
    this.setState({ showAlert: true })
  }

  onEnableRememberMeChange = (event) => {
    this.setState({
      enableRememberMe: event.target.checked
    })
  }

  openForgotPasswordModal = (event) => {
    event.preventDefault()
    this.setState({
      showForgotPasswordModal: true
    })
  }

  hideForgotPasswordModal = () => {
    this.setState({
      showForgotPasswordModal: false
    })
  }

  onSubmit = (event) => {
    event.preventDefault()
    
    this.props.form.validateFields((error, values) => {
      if (!error) {
        console.log(values.remember)
        this.props.onSubmit({
          username: values.username,
          password: values.password,
          enableRememberMe:values.remember
        })
      }
    })
    return false
  }

  render () {
    const {
      intl: { formatMessage },
    } = this.context

    const {
      header,
      style,
      errorMessage,
      isAuthenticating,
      forgotPassword,
      forgotPasswordErrorMessage,
      isForgotPasswordLoading,
      isForgotPasswordSuccess,
      initForgotPassword,
      form
    } = this.props

    const {
      username,
      password,
      enableRememberMe,
      showAlert,
      showForgotPasswordModal
    } = this.state
    const { getFieldDecorator } = form
    return (
      <div style={style}>
        <Form onSubmit={this.onSubmit} className='login-form'>
          { header }
          {
            showAlert ? (
              <Alert message='Error' type='error' description={errorMessage} showIcon />
            ) : (
              <div />
            )
          }
          <Form.Item>
            {getFieldDecorator('username', {
              rules: [{ required: true, message: 'Please input your username!' }],
            })(
              <Input
                prefix={<Icon type='user' style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder={formatMessage(messages.placeholderUsername)}
              />,
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Please input your Password!' }],
            })(
              <Input
                prefix={<Icon type='lock' style={{ color: 'rgba(0,0,0,.25)' }} />}
                type='password'
                placeholder={formatMessage(messages.placeholderPassword)}
              />,
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('remember', {
              valuePropName: 'checked',
              initialValue: enableRememberMe,
            })(<Checkbox><span style={{ color:'#FFF' }}>{formatMessage(messages.labelRememberMe)}</span></Checkbox>)}
            {/* <a className='login-form-forgot' href='#' onClick={this.openForgotPasswordModal}>
              {formatMessage(messages.labelForgotPassword)}
            </a> */}
            <Button type='primary' htmlType='submit' className='login-form-button'>
              {formatMessage(messages.buttonLogin)}
            </Button>
          </Form.Item>
        </Form>
        <ForgotPasswordModal
          emailOrUsername={username}
          onSubmit={forgotPassword}
          onHide={this.hideForgotPasswordModal}
          show={showForgotPasswordModal}
          errorMessage={forgotPasswordErrorMessage}
          isLoading={isForgotPasswordLoading}
          isSuccess={isForgotPasswordSuccess}
          init={initForgotPassword}
        />
      </div>
    )
  }
}

const Login = Form.create()(LoginForm)

export default Login



// WEBPACK FOOTER //
// ./src/components/LoginForm/LoginForm.js